import React from 'react';
import { formatCurrency } from '../utils/calculations';

export default function HoldingCostEstimator({ values = {}, onChange }) {
  const {
    months = 6,
    taxes = 250,
    insurance = 150,
    utilities = 200,
    hoa = 0,
    other = 100
  } = values;

  const update = (field, val) => {
    const num = parseFloat(val) || 0;
    onChange && onChange({ ...values, [field]: num });
  };

  const monthly = taxes + insurance + utilities + hoa + other;
  const total = monthly * months;

  const items = [
    { key: 'taxes', label: 'Property Taxes' },
    { key: 'insurance', label: 'Insurance' },
    { key: 'utilities', label: 'Utilities' },
    { key: 'hoa', label: 'HOA Fees' },
    { key: 'other', label: 'Other' }
  ];

  return (
    <div>
      {/* Months Slider */}
      <div className="form-group" style={{ marginBottom: 20 }}>
        <label>Holding Period: <strong style={{ color: 'var(--primary-light)' }}>{months} months</strong></label>
        <input
          type="range"
          min="1" max="24" step="1"
          value={months}
          onChange={e => update('months', e.target.value)}
          style={{ width: '100%', marginTop: 6 }}
        />
        <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: '0.75rem', color: 'var(--text-muted)' }}>
          <span>1 month</span>
          <span>24 months</span>
        </div>
      </div>

      {/* Monthly Cost Inputs */}
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: 12, marginBottom: 16 }}>
        {items.map(item => (
          <div key={item.key} className="form-group" style={{ margin: 0 }}>
            <label>{item.label}/mo</label>
            <div style={{ position: 'relative' }}>
              <span style={{
                position: 'absolute', left: 10, top: '50%', transform: 'translateY(-50%)',
                color: 'var(--text-muted)', fontSize: '0.9rem'
              }}>$</span>
              <input
                type="number"
                className="input"
                value={values[item.key] ?? 0}
                onChange={e => update(item.key, e.target.value)}
                min="0"
                style={{ paddingLeft: 24 }}
              />
            </div>
          </div>
        ))}
      </div>

      {/* Summary */}
      <div style={{
        background: 'var(--bg-dark)',
        borderRadius: 10,
        padding: '16px',
        border: '1px solid var(--border)'
      }}>
        <div style={{ display: 'flex', flexDirection: 'column', gap: 8, marginBottom: 12 }}>
          {items.map(item => {
            const val = values[item.key] || 0;
            const itemTotal = val * months;
            if (itemTotal === 0) return null;
            return (
              <div key={item.key} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <span style={{ fontSize: '0.85rem', color: 'var(--text-secondary)' }}>
                  {item.label}
                  <span style={{ color: 'var(--text-muted)', fontSize: '0.75rem', marginLeft: 4 }}>
                    ({formatCurrency(val)}/mo × {months})
                  </span>
                </span>
                <span style={{ fontSize: '0.85rem', fontWeight: 600, color: 'var(--text-primary)' }}>
                  {formatCurrency(itemTotal)}
                </span>
              </div>
            );
          })}
        </div>

        <div style={{ borderTop: '1px solid var(--border)', paddingTop: 12, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <div>
            <div style={{ fontSize: '0.8rem', color: 'var(--text-muted)' }}>Monthly: {formatCurrency(monthly)}</div>
            <div style={{ fontSize: '0.75rem', color: 'var(--text-muted)' }}>× {months} months</div>
          </div>
          <div style={{ textAlign: 'right' }}>
            <div style={{ fontSize: '0.75rem', color: 'var(--text-muted)', textTransform: 'uppercase', letterSpacing: '0.05em' }}>Total Holding</div>
            <div style={{ fontSize: '1.5rem', fontWeight: 800, color: '#f59e0b' }}>
              {formatCurrency(total)}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
